export enum BookingPageErrorState {
    None = 'None',
    ExpiredLink = 'ExpiredLink', // SignedUrl auth token has expired
    SingleUseLinkAlreadyUsed = 'SingleUseLinkAlreadyUsed', // A meeting has been already booked using the single-use link
    InvalidSignedUrl = 'InvalidSignedUrl',
    NoBookingPageDataPayload = 'NoBookingPageDataPayload', // Couldn't get booking page data payload
    NoPublicMeetingTypes = 'NoPublicMeetingTypes', // Booking page has loaded, but doesn't have any active public meeting types available
    ErrorAccessDenied = 'ErrorAccessDenied', // The user does not have access to the booking page, likely tenant admin blocked, 403 from substrate REST requests or required flight not yet enabled.
    ErrorUnlicensedUser = 'ErrorUnlicensedUser', // The user does not have a valid license (SKU) M365/O365 E3, E5, A3, A6, etc., required to access to the booking page
    ErrorAnonymousSharingDisabled = 'ErrorAnonymousSharingDisabled', // Anonymous sharing is disabled for the tenant
    DeprecatedPage = 'DeprecatedPage', // Show deprecation message
    ErrorPersonalBookingsNotEnabled = 'ErrorPersonalBookingsNotEnabled',
}
